var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.109 22.5274L94.7 13.1279L87.3295 20.532L96.6864 29.9315L104.109 22.5274ZM89.6818 52.2489H74V62.7511H89.6818V52.2489ZM136.727 0H126.273V15.4909H136.727V0V0ZM175.67 20.532L168.3 13.1279L158.943 22.5274L166.314 29.9315L175.67 20.532ZM158.891 92.4726L168.248 101.925L175.618 94.5205L166.209 85.121L158.891 92.4726ZM173.318 52.2489V62.7511H189V52.2489H173.318ZM131.5 25.9931C114.198 25.9931 100.136 40.1187 100.136 57.5C100.136 74.8813 114.198 89.0068 131.5 89.0068C148.802 89.0068 162.864 74.8813 162.864 57.5C162.864 40.1187 148.802 25.9931 131.5 25.9931ZM126.273 115H136.727V99.5091H126.273V115ZM87.3295 94.468L94.7 101.872L104.057 92.4201L96.6864 85.016L87.3295 94.468Z",
    fill: "#FFEC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.062 79.035C131.246 54.4537 109.783 36 84 36C63.5292 36 45.75 47.685 36.8958 64.785C15.575 67.065 -1 85.2337 -1 107.25C-1 130.834 18.0542 150 41.5 150H133.583C153.133 150 169 134.04 169 114.375C169 95.565 154.479 80.3175 136.062 79.035Z",
    fill: "#F2F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9999 155C70.5999 155 66.9999 158.6 66.9999 163C66.9999 167.4 70.5999 171 74.9999 171C79.3999 171 82.9999 167.4 82.9999 163C82.9999 158.6 79.3999 155 74.9999 155ZM58.9999 171C54.5999 171 50.9999 174.6 50.9999 179C50.9999 183.4 54.5999 187 58.9999 187C63.3999 187 66.9999 183.4 66.9999 179C66.9999 174.6 63.3999 171 58.9999 171ZM90.9999 171C86.5999 171 82.9999 174.6 82.9999 179C82.9999 183.4 86.5999 187 90.9999 187C95.3999 187 98.9999 183.4 98.9999 179C98.9999 174.6 95.3999 171 90.9999 171ZM107 155C102.6 155 98.9999 158.6 98.9999 163C98.9999 167.4 102.6 171 107 171C111.4 171 115 167.4 115 163C115 158.6 111.4 155 107 155Z",
    fill: "var(--rain-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 163C35 158.6 38.6 155 43 155C47.4 155 51 158.6 51 163C51 167.4 47.4 171 43 171C38.6 171 35 167.4 35 163Z",
    fill: "var(--rain-fill)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.99e032e8f59b7b7eb960f48ed6625e2d.svg";
export { ForwardRef as ReactComponent };